// Macro-categorie e settori europei ad alta richiesta + suggerimenti stile per settore
export const SECTOR_GROUPS = [
  { id: "food", sectors: ["restaurant", "bar", "hotel", "pastry"], layout: "classic", palette: "onyx" },
  { id: "beauty", sectors: ["hair", "beauty", "spa", "tattoo"], layout: "minimal", palette: "pearl" },
  { id: "health", sectors: ["medical", "vet", "legal"], layout: "minimal", palette: "royal" },
  { id: "services", sectors: ["mechanic", "home", "plumber", "realestate"], layout: "classic", palette: "graphite" },
  { id: "sport", sectors: ["gym", "dance", "beach"], layout: "lux", palette: "onyx" },
  { id: "retail", sectors: ["fashion", "optics", "grocery", "cars"], layout: "classic", palette: "silver" },
];
export const OTHER_SECTOR = "other";
export const groupOf = (sectorId) => SECTOR_GROUPS.find((g) => g.sectors.includes(sectorId)) || null;
